/**
 * QuestionnaireResponse.tsx — V4-6-2.
 *
 * /building/questionnaire-response — public landing for suppliers
 * arriving to answer a questionnaire. Points to sign-up/sign-in.
 */

import { Link } from 'react-router-dom';
import { Button, PageHeader } from '@aigovops/design-system';

export function QuestionnaireResponse() {
  return (
    <div style={{
      maxWidth: 720,
      margin: '0 auto',
      padding: 'var(--space-6) var(--space-4)',
      fontFamily: 'var(--font-ui)',
    }}>
      <PageHeader
        title="Answer an AI questionnaire"
        subtitle="Sign in to your workspace, and your answers are grounded in your released register entries — every answer already attested."
      />

      <div style={{
        marginTop: 'var(--space-4)',
        padding: 'var(--space-4)',
        border: '1px solid var(--border)',
        borderLeft: '4px solid var(--building)',
        borderRadius: 'var(--radius-card)',
        background: 'var(--surface)',
        fontSize: 'var(--font-size-2xs)',
        color: 'var(--text-muted)',
        lineHeight: 1.6,
      }}>
        Upload the questionnaire (XLSX, SIG, CAIQ). gacpro maps the questions to your
        register entries and drafts answers with per-field citations. Review, edit, export.
        One day, not six weeks.
      </div>

      <div style={{ marginTop: 'var(--space-4)', display: 'flex', gap: 'var(--space-3)' }}>
        <Link to="/signin">
          <Button>Sign in to your workspace</Button>
        </Link>
        <Link to="/signup">
          <Button variant="secondary">Create a workspace</Button>
        </Link>
      </div>
    </div>
  );
}
